import React from 'react';
import { Link } from 'react-router-dom';
import Image from 'theme/Image';
import $S from 'theme/settings';
import { thumbnailImageUrl, currencyText, objectSelector } from 'theme/utils';

export default function ProductItem(props) {
  const { product } = props;

  const basketOfferQuantity = objectSelector(
    product,
    'basket_offers.0.listing_kwargs.quantity'
  );
  const discountedPrice = objectSelector(
    product,
    'basket_offers.0.listing_kwargs.discounted_total_price'
  );
  const isValidBasketOffer = basketOfferQuantity === 1 && !!discountedPrice;
  const hasDiscountPrice =
    isValidBasketOffer || product.retail_price !== product.price;

  const getDiscountedPriceField = () => {
    if (isValidBasketOffer) {
      return (
        <span className='discounted-price'>
          {currencyText(product.currency_type)} {discountedPrice}
        </span>
      );
    }
    if (product.retail_price !== product.price) {
      return (
        <span className='discounted-price'>
          {currencyText(product.currency_type)} {product.price}
        </span>
      );
    }
    return null;
  };

  return (
    <div className='col-xs-12 col-sm-6 col-md-3 col-lg-2'>
      <div className='product-item '>
        <Link to={'/product/' + product.pk}>
          <Image
            src={thumbnailImageUrl(
              product.productimage_set.length
                ? product.productimage_set[0].image
                : null,
              $S.productListImageWidth,
              $S.productListImageHeight,
              $S.productListImageQuality
            )}
            classes='product-item__imageWrapper object-contain'
            width={$S.productListImageWidth}
            height={$S.productListImageHeight}
          />
          <p>{product.name}</p>
          <div className='prices'>
            <p>
              <span className={hasDiscountPrice ? 'old-price' : 'list-price'}>
                {currencyText(product.currency_type)} {product.retail_price}
              </span>
              {getDiscountedPriceField()}
            </p>
          </div>
        </Link>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/product/list/ProductItem.js